import {Component, ViewEncapsulation, Input, OnInit} from '@angular/core';
import { RoomPreview } from '../../models/property/room-preview';
import { RentPaymentFrequencies } from '../../models/tenancy/rent-payment-frequencies';
import { Address } from '../../models/address/address';
import { BillsInclusiveTypes } from '../../models/property/bills-inclusive-types';
import {OrganisationProfile} from "../../models/organisation/organisation-profile";
import {HomePreview} from "../../models/property/home-preview";
import {HOME} from "@angular/cdk/keycodes";

@Component({
    selector: 'home-landing-preview-card',
    templateUrl: './home-landing-preview-card.component.html',
    encapsulation: ViewEncapsulation.None
})

export class HomeLandingPreviewCardComponent implements OnInit {

    @Input() homePreview: HomePreview;
    @Input() majorArea: Address;
    @Input() showAddress: boolean = false;
    @Input() organisation: boolean = false;
    @Input() organisationProfile: OrganisationProfile;
    RentPaymentFrequencies = RentPaymentFrequencies;
    BillsInclusiveTypes = BillsInclusiveTypes;

    open: boolean = false;

    constructor() {
        if (!this.majorArea && this.homePreview && !this.homePreview.majorArea) {
            this.homePreview.majorArea = this.majorArea;
        }
    }

    ngOnInit(): void {
        if (this.homePreview.organisationProfile == null) {
            this.homePreview.organisationProfile = this.organisationProfile;
        }
    }

    clickProperty() {

        if (this.homePreview.availableRooms.length > 1) {
            this.toggleOpen();
            event.preventDefault();
            event.stopPropagation();
        }
    }

    toggleOpen() {
        this.open = !this.open;
    }
}
